export interface Rooms {
  roomId: number;
  roomNumber: string;
  roomName: string;
  roomType: string;
  roomCategory: string;
  status: string;
  rate: number;
  description: string;
  maxOccupancy: number;
  amenities: string;

  dateAdded: string;     // ISO 8601 string
  updatedAt: string;     // ISO 8601 string

  imageUrl: string;
  floorNumber: number;
  roomView: string;
  isSmokingAllowed: boolean;
  bedType: string;
  roomDimensions: string;
  accessibilityFeatures: string;
  roomPolicies: string;
}
export const initializedRooms: Rooms = {
  roomId: 0,
  roomNumber: "",
  roomName: "",
  roomType: "",
  roomCategory: "",
  status: "",
  rate: 0,
  description: "",
  maxOccupancy: 0,
  amenities: "",
  dateAdded: new Date().toISOString(),
  updatedAt: new Date().toISOString(),
  imageUrl: "",
  floorNumber: 0,
  roomView: "",
  isSmokingAllowed: false,
  bedType: "",
  roomDimensions: "",
  accessibilityFeatures: "",
  roomPolicies: ""
};


export interface FetcheRooms {
  roomId: number;
  roomNumber: string;
  roomName?: string;
  roomType: string;
  roomCategory: string;
  status: string;
  rate: number;
  description?: string;
  maxOccupancy: number;
  amenities?: string;
  updatedAt?: string | number | Date;
  dateAdded?: string | number | Date;
  imageUrl?: string;
  floorNumber?: number;
  roomView?: string;
  isSmokingAllowed?: boolean;
  bedType?: string;
  roomDimensions?: string;
  accessibilityFeatures?: string;
  roomPolicies?: string;
}